/**
 * FilterDrawer class represents a custom web component that extends the Drawer class.
 * It provides methods for opening a filter drawer and loading its content lazily.
 */
class DebugDrawer extends window.Drawer {}

// Define the 'filter-drawer' custom element using the FilterDrawer class.
window.customElements.define('debug-drawer', DebugDrawer)
